// TODO: Move buildLrpUrl to aurora-node-url-builder

import compact from 'lodash/compact';
import { seoUrlPart } from '@ecg-marktplaats/aurora-js-formatters';

/**
 * Check whether a url is a query url (/q) or l1 url (/l)
 *
 * @param {string} url
 * @return {boolean}
 */
export const isQueryUrl = (url = ''): boolean => url.includes('/q');

/**
 * builds the LRP URL for a given category and params
 *
 * @param {string} lrpBaseUrl | Should be either /l/<l1-category-name> or /q/<query>
 * @param {string} categoryName
 * @param {object} params
 * @return {string}
 */
type TParams = {
  query?: string;
  distance?: string | number;
  postcode?: string;
  condition?: string | number;
};
// TODO: move to server (maybe expose as API) to utilize @ecg-marktplaats/aurora-node-url-builder helper function.
export const buildLrpUrl = (lrpBaseUrl?: string, categoryName = '', params: TParams = {}): string => {
  if (!lrpBaseUrl) {
    return '';
  }

  // if it's a /q URL with a categoryName then remove the query because it will be added as an attribute.
  const baseUrl = isQueryUrl(lrpBaseUrl) && categoryName ? '/l' : lrpBaseUrl;

  const categoryUrlPart = categoryName ? `/${seoUrlPart(categoryName)}` : '';

  const { query, distance, postcode, condition } = params;
  const paramsString = compact([
    query && !isQueryUrl(baseUrl) && `q:${query}`,
    distance && `distanceMeters:${distance}`,
    postcode && `postcode:${postcode}`,
    condition && `f:${condition}`,
  ]).join('|');
  const paramsUrlPart = paramsString ? `/#${paramsString}` : '';

  return baseUrl + categoryUrlPart + paramsUrlPart;
};

export const getLrpUrlWithQuery = (lrpBaseUrl: string, query?: string) => {
  if (!query || isQueryUrl(lrpBaseUrl)) {
    return lrpBaseUrl;
  }

  return `${lrpBaseUrl}/#q:${query}`;
};
